let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2KYlV")).then(() => parcelRequire('l3U2S'));